import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators';

import { isDefined } from '../../helpers/utils';
import organizationInfo from '../../helpers/state/organization-info';

@customElement('access-item')
export class AccessItem extends LitElement {
    @property({ type: String })
    email: string = '';

    @property({ type: String })
    accessLevel: string = 'Editor';

    @property({ type: Boolean })
    canDelete: boolean = false;

    @property({ type: Boolean })
    haveAvatar: boolean = false;

    render() {
        return html`
            <div slot="summary" class="summary">
                <div id="summaryname">
                    <label class="formLabel">${this.email}</label>
                    <div class="formValue">${isDefined(organizationInfo.organization) ? 'Team' : ''} ${this.accessLevel}</div>
                </div>
            </div>
        `;
    }

    static get styles() {
        return css`
            .summary {
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
            }

            #summaryname {
                flex: 1;
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex-direction: row;
            }

            .formLabel {
                color: var(--theme-input-color);
                font-size: 0.75rem;
                font-weight: bold;
            }

            .formValue {
                color: var(--theme-input-color);
                font-size: 0.75rem;
                font-style: italic;
                word-break: break-all;
            }
        `;
    }
}
